export default {
  newDesign: true,
  title: "Ücretsiz Matematik Dersi: Güveni ve Başarıyı Artırın | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrMathSh",
    segment: 12,
  },
  startPage: {
    title:
      "Ücretsiz Matematik Dersi: Güveni ve Başarıyı Artırın",
    subtitle:
      "Çocuğunuz için ücretsiz bir deneme dersi açmak üzere 1 dakikalık testimizi çözün. Kodland’ın stressiz yaklaşımı, matematikle ilgili zorlukları okul başarısına dönüştürüyor",
    image: {
      url: "/welcome/tr_sp_math_a_short_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_sp_math_a_short_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Ücretsiz almak için tıklayın ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz matematik hakkında nasıl hissediyor? 🧮",
      answers: [
        "🥳 Eğlenceli ama bazen zorlayıcı",
        "😊 Fena değil, ama ekstra destek gerekli",
        "😔 Zorlayıcı ve can sıkıcı",
        "😢 Bunaltıcı geliyor"
      ],
    },
    2: {
      question: "Çocuğunuz son matematik ödevinde nasıl bir performans gösterdi?",
      answers: [
        "🌟 85–100 (Mükemmel)",
        "😊 70–84 (İyi)",
        "😐 60–69 (Orta)",
        "😟 50–59 (Ortanın Altı)",
        "😢 0–49 (Zorlanıyor)"
      ],
    },
    3: {
      question: "Çocuğunuzun matematikteki en büyük hedefi nedir?",
      answers: [
        "📈 Notları yükseltmek ve 'yeni nesil' soruları geçmek",
        "🌟 Odaklanmayı ve özgüveni artırmak",
        "🏫 Lise ve gelecek sınavlar için hazırlık yapmak",
        "🤓 Stresi azaltmak ve matematiği daha kolay anlamak"
      ],
    },
    4: {
      question: "Çocuğunuzun matematik ve gelecekteki sınavlar için ekstra desteğe ihtiyacı var mı?",
      answers: [
        "✅ Evet, düzenli desteğe ihtiyaçları var",
        "🤔 Belki, şimdilik idare ediyor ama ekstra yardım iyi olabilir",
        "❌ Hayır, şu anki ilerlemeleriyle gayet iyi gidiyorlar"
      ],
    },
    5: {
      title: "Çocuğunuzun Yaşını Seçin",
      subtitle: "Uzman öğretmenlerimiz, çocuğunuzun matematik özgüveni kazanmasını ve okul performansını artırmasını sağlar.",
      type: "age",
      button: "",
    },
    6: {
      question:
        "Çocuğunuzun çalışması için bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "👍 Evet",
        {
          answer: "👎 Hayır",
          stopAnswer: true,
        },
      ],
    },
    7: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Lütfen not edin:<br>• Çalışan bir bilgisayar veya dizüstü gerekli.<br>• Ders sırasında ebeveyn bulunmalı.<br>• Dersler, özgüveni ve matematik başarısını artırmak için kişiselleştirilmiştir.Adım adım matematik zorluklarını aşalım!",
      button: "Sırada ne var?",
    },
    10: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    11: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
